/**
 * Created by linjianxi on 2016/11/17.
 */

import * as types from './mutation-type'
import * as http from '../../../utils/common'

/**
 * 获取周排行版
 * @param commit
 * @param params
 */
export const getWeekTop = ({commit}, params) => {
  http.post({
    url: '/LVB/api/User/GetWeekAtributionTopList',
    data: params.data,
    succ: function (res) {
      console.log(res)
      if (res.result === 1) {
        commit(types.WEEK_TOP_LIST, res.data)
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ticket/actions.js